import {
  getDashboardStats,
  getSalesOverview,
  getRecentOrders,
  getTopSellingProducts,
} from "../../../services/dashboardService";
import {
  getDashboardStatsStart,
  getDashboardStatsSuccess,
  getDashboardStatsFailure,
  getSalesOverviewStart,
  getSalesOverviewSuccess,
  getSalesOverviewFailure,
  getRecentOrdersStart,
  getRecentOrdersSuccess,
  getRecentOrdersFailure,
  getTopSellingProductsStart,
  getTopSellingProductsSuccess,
  getTopSellingProductsFailure,
} from "../dashbaord/dashboardSlice";

export const fetchDashboardStats = () => async (dispatch) => {
  try {
    dispatch(getDashboardStatsStart());
    const response = await getDashboardStats();
    dispatch(getDashboardStatsSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getDashboardStatsFailure(error.message));
    throw error;
  }
};

export const fetchSalesOverview = () => async (dispatch) => {
  try {
    dispatch(getSalesOverviewStart());
    const response = await getSalesOverview();
    dispatch(getSalesOverviewSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getSalesOverviewFailure(error.message));
    throw error;
  }
};

export const fetchRecentOrders = () => async (dispatch) => {
  try {
    dispatch(getRecentOrdersStart());
    const response = await getRecentOrders();
    dispatch(getRecentOrdersSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getRecentOrdersFailure(error.message));
    throw error;
  }
};

export const fetchTopSellingProducts = () => async (dispatch) => {
  try {
    dispatch(getTopSellingProductsStart());
    const response = await getTopSellingProducts();
    dispatch(getTopSellingProductsSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTopSellingProductsFailure(error.message));
    throw error;
  }
};

